import * as Identity from '@spica-devkit/identity';
import { localStorageService, STORAGE_KEY } from './local-storage.service';
import fnService from './function.service';
export class Authentication {
  publicUrl = process.env.REACT_APP_API_URL;

  initializeIdentity() {
    Identity.initialize({
      publicUrl: this.publicUrl,
      apikey: process.env.REACT_APP_PUBLIC_APIKEY!,
    });
  }

  singIn(token: string) {
    return new Promise((res, rej) => {
      fnService
        .login(token)
        .then((result: any) => {
          localStorageService.setItem(STORAGE_KEY.TOKEN, result.token);
          res(result);
        })
        .catch((err: any) => {
          console.log(err);
          rej(err);
        });
    });
  }

  logOut() {
    localStorageService.removeItem(STORAGE_KEY.TOKEN);
    localStorageService.removeItem(STORAGE_KEY.USER);
  }

  verifyToken = (token: string) => {
    this.initializeIdentity();
    return Identity.verifyToken(token!);
  };

  setToken(token: string) {
    localStorageService.setItem(STORAGE_KEY.TOKEN, token);
  }

  getToken() {
    return localStorageService.getItem(STORAGE_KEY.TOKEN);
  }

  isLoggedIn() {
    return !!this.getToken();
  }
}
const authService = new Authentication();
export default authService;
